import { render } from "./process-detail.vue?vue&type=template&id=5bd51873"
import script from "./process-detail.vue?vue&type=script&lang=js"
export * from "./process-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__